import styled from 'styled-components/macro';
import { Scrollbar } from '~/components';

export const Content = styled(Scrollbar)`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.light2};
  flex: 1 1 0;
  overflow-y: auto;
`;
